/** @jsx jsx */

import React, { Fragment as _, useContext } from 'react';
import { css, jsx } from '@emotion/core';

const Assessment = ({ children, ...props }) => {
  // console.log('Assessment', children);

  return (
    <div
      css={css`
        padding: 10px;
      `}
    >
      {children}
    </div>
  );
};

export default Assessment;
